import { Dispatch, createContext } from "react";
import { AppReducerAction, IAppReducerState } from "./AppReducer";

export interface IAppContext {
    state: IAppReducerState;
    dispatch: Dispatch<AppReducerAction>;
}

export const AppContext = createContext<IAppContext | undefined>(undefined)